import React from 'react'
import { GameResultListLayer } from '../components/GameResult/GameResultListLayer'
import MasterLayout from '../masterLayout/MasterLayout'

export const GameResultListPage = () => {
  return (
    <MasterLayout>

        <GameResultListLayer />
    </MasterLayout>
  )
}
